<template>
  <v-card>
    <v-card-title class="headline">
      Meu score
    </v-card-title>
    <v-card-text class="text--primary">
      <v-icon large>
        mdi-calculator
      </v-icon>
      <span class="headline ml-3">
        <px-transportador-score :score="transportador.score"/>
      </span>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    transportador: Object,
  },
};
</script>
